module.exports = "<div class=\"row p-l-15 p-r-15 m-b-10 m-l-0 m-r-0\">\n  <div class=\"col-sm-9 p-l-0 p-r-0\">\n    <h3>{{$ctrl.title}}</h3>\n  </div>\n  <div class=\"col-sm-3 text-right\">\n    <h3 ng-transclude>\n    </h3>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/page-header/page-header.html
// module id = 401
// module chunks = 1